import { render, staticRenderFns } from "./MediaBox.vue?vue&type=template&id=380a4a83&"
import script from "./MediaBox.vue?vue&type=script&lang=js&"
export * from "./MediaBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports